import useZoomVideoContext from './useZoomVideoContext/useZoomVideoContext';

export default function useScreenShareParticipantZoom() {
  const { zoomSession } = useZoomVideoContext();
  return zoomSession?.getShareUserList()[0];
}
